






import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const setting = namespace("setting");

@Component({})
export default class ShowDone extends Vue {
  @setting.State serviceMode;
  // MODE_S(1,"标准模式"),
  // MODE_A(2,"快捷模式 A"),
  // MODE_B(3,"快捷模式 B")

  // settlementStatus 0: 未结算 1：已结算
  // orderType 1: 维保 2：洗车 3：零售
  // orderSource 1: 到店 2：天猫 3：小程序
  @Prop({ default: () => ({}) })
  orderData: any;
  get $show() {
    if (this.orderData.orderType === "2" || this.orderData.orderType === "3") {
      // 洗车零售，没有完成操作
      return false;
    }
    if (this.serviceMode === "1") {
      // 标准模式
      if (this.orderData.orderSource === "1" && this.orderData.arrivalShop) {
        // 到店订单
        if (this.orderData.orderStatus === "2" && !this.orderData.outboundNo) {
          return true;
        }
        if (this.orderData.orderStatus === "3") {
          return true;
        }
      } else {
        // 非到店订单
        if (this.orderData.orderStatus === "3" && this.orderData.arrivalShop) {
          return true;
        }
      }
    } else if (this.serviceMode === "2") {
      // 快捷模式A
      //
    } else {
      // 快捷模式B
      if (this.orderData.orderSource === "1" && this.orderData.arrivalShop) {
        // 到店订单
        if (this.orderData.orderStatus === "2") {
          return true;
        }
      } else {
        // 非到店订单
        if (this.orderData.orderStatus === "2" && this.orderData.arrivalShop) {
          return true;
        }
      }
    }
    return false;
  }
}
